import { format } from "fecha";

import { getNews } from "../../../api/news/get";
import { orderByDescending } from "../../../utils/arrayutil/orderby";
import hx from "../../../utils/hydroxie";
import { parseNewsText } from "../../../utils/parsenewstext";

/**
 * ランディングページ→お知らせエリア
 */
export class NewsArea {
    /** お知らせエリアのルート要素 */
    #elem: HTMLElement;

    /**
     * コンストラクター。
     *
     * @param elem お知らせエリアのルート要素
     */
    constructor(elem: HTMLElement) {
        this.#elem = elem;
    }

    /**
     * 初期化処理を行う。
     * ニュースデータを取得して表示する。
     */
    async init() {
        const news = await getNews();
        const contents = orderByDescending(news, (item) => item.date)
            // とりあえず最新5件とする
            .slice(0, 5)
            .map((x) => {
                try {
                    return hx("",
                        hx("div", { className: "news-date" }, format(new Date(x.date), "YYYY-MM-DD")),
                        hx("div", { className: "news-text" }, parseNewsText(x.text)));
                } catch (e) {
                    console.error(e);
                    return hx("");
                }
            });

        this.#elem.replaceChildren(...contents);
    }
}
